var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQtSelectOne = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M140 35.327c57.81 0 104.673 46.863 104.673 104.673S197.81 244.673 140 244.673 35.327 197.81 35.327 140 82.19 35.327 140 35.327m0 70.907c-18.648 0-33.766 15.118-33.766 33.766s15.118 33.766 33.766 33.766 33.766-15.118 33.766-33.766c-.022-18.64-15.127-33.744-33.766-33.766"
})));
export default SvgQtSelectOne;